import * as THREE from 'three';
import {
  CARD1Web,
} from '../../CoordUtils.js';

import {
  ModelLoader
} from '@/drawings3D/ModelLoader';

import {
  BannerContent
} from '@/drawings3D/models/BannerContent';

//这个类用来载入路牌所需要的各种贴图，使用canvas实现
export class BannerLoader extends ModelLoader {
  constructor(modelInfo, sceneManager) {
    super(sceneManager, modelInfo);
    this.bannerContent = new BannerContent(modelInfo.extraPartConfig.bannerStyle, modelInfo.extraPartConfig.contentArray);
    
  }

  loadExtraParts(extraPart, loadedMesh) {
    this.bannerGeom = new THREE.BoxGeometry(this.bannerContent.getBannerWidth(), 0.01, this.bannerContent.getBannerHeight());
    this.bannerMap = new THREE.Texture(this.bannerContent.getDrawingCanvas().get());
    this.bannerMap.needsUpdate = true
    this.bannerMaterials = new Array();

    for (var i=0;i<6;i++){
      var material = new THREE.MeshPhongMaterial();
      material.map = this.bannerMap;
      this.bannerMaterials.push(material);
    }
    this.bannerMesh = new THREE.Mesh(this.bannerGeom, this.bannerMaterials);
    this.bannerGeom.rotateX(Math.PI / 2);
    this.bannerGeom.rotateY(Math.PI-0.02);
    this.bannerGeom.translate(2.95,7.5, -0.01); 
    this.loadedMesh.add(this.bannerMesh);

    this.bannerGeom.ownerDrawer = this.loadedMesh.ownerDrawer;
    loadedMesh.oInfo = extraPart.option.option.info;
  }

}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/modelDrawing/DirectModel/BannerLoader.js